<template lang="pug">
    div.frequency
        v-select(
            label="Frequency update"
            :value="frequency"
            :items="items"
            outlined
            @change="refreshAction"
        )
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            frequency: VueTypes.number.def(0),
            refreshAction: VueTypes.func.def(() => {}),
        },
        data() {
            return {
                time: this.frequency,
                items: [
                    {
                        text: 'On demand',
                        value: 0,
                    },
                    {
                        text: '5s',
                        value: 5,
                    },
                    {
                        text: '10s',
                        value: 10,
                    },
                    {
                        text: '20s',
                        value: 20,
                    },
                    {
                        text: '30s',
                        value: 30,
                    },
                    {
                        text: '40s',
                        value: 40,
                    },
                    {
                        text: '60s',
                        value: 60,
                    },
                    {
                        text: '2 mins',
                        value: 120,
                    },
                    {
                        text: '3 mins',
                        value: 180,
                    },
                    {
                        text: '5 mins',
                        value: 300,
                    },
                    {
                        text: '10 mins',
                        value: 600,
                    },
                ],
            };
        },
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'

    .frequency
        max-width: 200px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .frequency
            max-width: 100%
</style>
